var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0003 0C31.0458 0 40.0003 8.95415 40.0003 20C40.0003 31.0456 31.0458 40 20.0003 40C8.95445 40.0003 0 31.0458 0 20C0 8.95415 8.95445 0 20.0003 0Z",
    fill: "#C0C6CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1245 26.2966H26.8758C30.6953 26.2966 33.8206 29.4219 33.8206 33.2414V34.4564C30.229 37.8907 25.3612 40.0001 20.0002 40.0001C14.6391 40.0001 9.77099 37.8904 6.17969 34.457V33.2414C6.17969 29.4219 9.30473 26.2966 13.1245 26.2966ZM20.0002 6.91309C24.7921 6.91309 28.6765 10.7978 28.6765 15.5894C28.6765 20.3814 24.7921 24.2664 20.0002 24.2664C15.2082 24.2664 11.3235 20.3814 11.3235 15.5894C11.3235 10.7978 15.2082 6.91309 20.0002 6.91309Z",
    fill: "#2A323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/avatar-default.f4c63081690cf087466b6250ed7814c0.svg";
export { ForwardRef as ReactComponent };